import Slide from '@/components/shared/Slide';
import ProgramCard from '@/components/shared/ProgramCard';
import type { RoadmapCompanyConfig, ViewMode } from '@/types/roadmap.types';

interface Props {
  config: RoadmapCompanyConfig;
  mode: ViewMode;
}

export default function LandscapePreviewSlide({ config, mode }: Props) {
  const { programs } = config;
  const preview = programs.slice(0, 3);

  return (
    <Slide mode={mode}>
      <div className="w-full max-w-7xl mx-auto">
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-primary mb-3">
          Preliminary Landscape
        </p>
        <h2 className="text-3xl sm:text-4xl font-bold tracking-tight text-foreground mb-2">
          Initial Findings
        </h2>
        <p className="text-sm text-muted-foreground mb-8">
          A preview of {preview.length} programs from {programs.length} identified
          matches.
        </p>

        <div className="space-y-3">
          {preview.map((prog) => (
            <ProgramCard key={prog.id} program={prog} compact />
          ))}
        </div>

        <p className="text-xs text-muted-foreground mt-6 text-center">
          Full details available in the Grant Roadmap deliverable.
        </p>
      </div>
    </Slide>
  );
}
